import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from '@/pages/home/components/Hero';
import Marquee from '@/pages/home/components/Marquee';
import About from '@/pages/home/components/About';
import Services from '@/pages/home/components/Services';
import Cases from '@/pages/home/components/Cases';
import Testimonial from '@/pages/home/components/Testimonial';
import CtaForm from '@/pages/home/components/CtaForm';

export default function Home() {
  return (
    <main className="w-full min-w-[320px] bg-background-50 text-foreground-900">
      <Navbar />
      <Hero />
      <Marquee />
      <About />
      <Services />
      <Cases />
      <Testimonial />
      <CtaForm />
      <Footer />
    </main>
  );
}